import { JSX } from 'react'

import { Flex, Box } from '@chakra-ui/react'

// eslint-disable-next-line @typescript-eslint/naming-convention
import Panel from './components/panel.tsx'

// eslint-disable-next-line @typescript-eslint/naming-convention
import Qrcode from './components/qrcode.tsx'




export default function
(dispatch: (expire: Date) => void): JSX.Element
{
	return (
		<Flex w="vw" h="vh" overflow="hidden" bg="blue.focusRing">
			<Box w="3/5" h="full">
				<Panel />
			</Box>

			<Box
				w="2/5"
				h="full"
				bg="white"
				_open={{ animation: 'slide-from-right 400ms ease-out' }}
				data-state="open"
			>
				<Qrcode dispatch={dispatch} />
			</Box>

		</Flex>

	)

}
